<template>
  <v-container fluid style="color: whitesmoke; background-color: gray;" fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center justify-center>
        <img src="@/assets/logo.png" alt="Brunello Cucinelli" class="mb-5">
        <!-- <blockquote>
          &#8220;The great dream of my life has always been to work for the moral and economic dignity of mankind.&#8221;
          <footer>
            <small>
              <em>&mdash;Brunello Cucinelli</em>
            </small>
          </footer>
        </blockquote> -->
        <blockquote>
          &#8220;Beauty will save the world&#8221;
          <footer>
            <small>
              <em>&mdash;Fyodor Dostoyevsky</em>
            </small>
          </footer>
        </blockquote>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
